import NavBar from "../Componentes/NavBar";
import GenericBody from "../Componentes/GenericBody";
import TabelaNcs from "../Modulos/Checklist/NaoConformidades/TabelaNcs";

const ChecklistNcs = () => {
    return(
        <>
            <NavBar title="LISTA DE NÃO CONFORMIDADES" prevDest="modulo/ssma/check-list" />
            <GenericBody>
                <TabelaNcs />
            </GenericBody>
        </>
    )
}

export default ChecklistNcs;